import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './CitySelect.css';
import Modal from '../../components/Modal';
import CitiesList from '../../components/CitiesList';
import { setCity, setCityPrepositional, setCityID, setCityPhone } from "../../actions/SetCity";
import { setFilterData } from "../../actions/FiltersActions";
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadCities } from '../../actions/CitiesActions';

const deg2rad = (deg) => {
  return deg * Math.PI / 180;
}

const error = (err) => {
  console.warn(`ERROR(${err.code}): ${err.message}`);
};

const options = {
  enableHighAccuracy: false,
  maximumAge: 0
};

class CitySelect extends Component {
  static requestData(store) {
    return requestAll([loadCities], store);
  }

  getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // радиус Земли в км
    const dLat = deg2rad(lat2-lat1);
    const dLon = deg2rad(lon2-lon1);
    const a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c; // дистанция в км
    return d;
  }

  setCityformCoords = (latitude, longitude) => {
    let mindif = 100; // максимальное расстояние в км для определения
    let closest;

    for (let index = 0; index < this.props.cities.length; ++index) {
      let dif = this.getDistanceFromLatLonInKm(latitude, longitude, this.props.cities[index].lat, this.props.cities[index].lng);
      if (dif < mindif) {
        closest = index;
        mindif = dif;
      }
    }
    if (this.props.cities[closest] !== undefined) {
      this.props.handleLoad(this.props.cities[closest].name, this.props.cities[closest].name_prepositional, this.props.cities[closest].id, this.props.cities[closest].phone, 'city');
    }
  }

  foundLocation = (position) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    // const latitude = 58.01741;
    // const longitude = 56.28552;
    this.setCityformCoords(latitude, longitude)
    const newCoords = JSON.stringify({latitude: position.coords.latitude, longitude: position.coords.longitude});
    if (typeof localStorage !== "undefined") {
      localStorage.setItem('coords', newCoords);
    }
  }

  componentDidMount() {
    this.props.actions.loadCities().then(() => {
      let oldCoords = {};
      if (typeof localStorage !== "undefined") {
        oldCoords = localStorage.getItem('coords');
      }
      if (!this.props.baseCitySelected && !this.props.location.search) {
        if (oldCoords) {
          const latitude = JSON.parse(oldCoords).latitude;
          const longitude = JSON.parse(oldCoords).longitude;
          this.setCityformCoords(latitude, longitude)
        } else {
          navigator.geolocation.getCurrentPosition(this.foundLocation, error, options);
        }
      }
    });
  }

  handleRemove = (e, id) => {
    var filterCity = this.props.filter.city.id
    filterCity = filterCity.filter(item => item.id !== id)
    this.props.handleRemove(filterCity);
  }

  render() {
    return (
      <div className={`citySelect ${this.props.modifier ? this.props.modifier : ''}`}>
        <div className="citySelect__title">
          <div className="citySelect__children">
            {this.props.children}
          </div>
          <div className="citySelect__wrapperName">
            <Modal className="citySelect__main" button={this.props.baseCityPrepositional}>
              <CitiesList cities={this.props.cities} multiply={false} />
            </Modal>
            <div className="citySelect__arrow" />
          </div>
        </div>
        {
          this.props.multiply &&
          <div className="citySelect__multi">
            {
              (Array.isArray(this.props.filter.city.id) && this.props.filter.city.id.length > 0) &&
              [
                !(this.props.filter.city.id.length === 1 && this.props.filter.city.id[0].id === this.props.baseCityID) &&
                <div className="citySelect__addText" key="citySelect__addText-key">А также</div>,
                this.props.filter.city.id.map((city, index) => (
                  this.props.baseCityID !== city.id &&
                  <div className="citySelect__addedCity" key={`citySelect__addedCity-${index}`}>
                    {city.label}
                    <div tabIndex="1" className="citySelect__deleteCity" onClick={(e) => this.handleRemove(e, city.id)} />
                  </div>
                ))
              ]
            }
            <Modal className="citySelect__addCity" button="добавить города">
              <CitiesList cities={this.props.cities} multiply={true} />
            </Modal>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      baseCityID: state.baseCity.baseCityID,
      baseCityPrepositional: state.baseCity.baseCityPrepositional,
      baseCitySelected: state.baseCity.baseCitySelectedByUser,
      cities: state.cities.list,
      hasErrored: state.cities.hasErrored,
      isLoading: state.cities.isLoading,
      filter: state.filter,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadCities }, dispatch),
    handleLoad: (baseCityName, baseCityPrepositional, baseCityID, baseCityPhone, type) => {
      dispatch(setCity(baseCityName));
      if (baseCityPrepositional) {
        dispatch(setCityPrepositional(baseCityPrepositional))
      } else {
        dispatch(setCityPrepositional(baseCityName))
      }
      dispatch(setCityID(baseCityID))
      dispatch(setCityPhone(baseCityPhone))
      dispatch(setFilterData(baseCityID, '', type))
    },
    handleRemove: (array) => {
      if (array.length > 0 || !(array.length === 1 && array[0].id === '')) {
        dispatch(setFilterData(array, '', "city"));
      } else {
        dispatch(setFilterData('', '', "city"));
      }
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CitySelect));



// WEBPACK FOOTER //
// ./src/components/CitySelect/index.js